// src/pages/Public/Payment/PaymentCancelPage.js
import { useEffect } from 'react';
import { Box, Typography, Paper, CircularProgress, Alert, Container } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import useEmbedMode from './useEmbedMode';

const PaymentCancelPage = () => {
    const embed = useEmbedMode();

    // Notify parent iframe of cancellation
    useEffect(() => {
        embed.postToParent('payment-status', { status: 'cancelled' });
    }, [embed]);

    return (
        <Container component="main" maxWidth="sm" sx={{ mb: 4, ...embed.containerSx }}>
            <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, textAlign: 'center', ...embed.paperSx }}>
                <>
                    <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main' }} />
                    <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
                        Payment Cancelled
                    </Typography>
                </>
            </Paper>
        </Container>
    );
};

export default PaymentCancelPage;
